var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeaRise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4286 11.4432C10.4286 10.8599 10.7722 10.3471 11.2284 10.0021C12.3052 9.18772 13 7.90286 13 6.45727C13 3.99559 10.9853 2 8.5 2C6.01472 2 4 3.99559 4 6.45727C4 7.90286 4.69477 9.18772 5.77161 10.0021C6.22779 10.3471 6.57143 10.8599 6.57143 11.4432C6.57143 11.8546 6.89481 12.188 7.29373 12.188H9.70627C10.1052 12.188 10.4286 11.8546 10.4286 11.4432Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42703 14.1882C6.42703 13.7399 6.77949 13.3765 7.21428 13.3765H9.78571C10.2205 13.3765 10.573 13.7399 10.573 14.1882C10.573 14.6366 10.2205 15 9.78571 15H7.21428C6.77949 15 6.42703 14.6366 6.42703 14.1882Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11.25C16.5858 11.25 16.25 11.5858 16.25 12C16.25 12.4142 16.5858 12.75 17 12.75H20.1893L12 20.9393L7.53033 16.4697C7.23744 16.1768 6.76256 16.1768 6.46967 16.4697L1.46967 21.4697C1.17678 21.7626 1.17678 22.2374 1.46967 22.5303C1.76256 22.8232 2.23744 22.8232 2.53033 22.5303L7 18.0607L11.4697 22.5303C11.7626 22.8232 12.2374 22.8232 12.5303 22.5303L21.25 13.8107V17C21.25 17.4142 21.5858 17.75 22 17.75C22.4142 17.75 22.75 17.4142 22.75 17V12C22.75 11.5858 22.4142 11.25 22 11.25H17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaRise);
export default __webpack_public_path__ + "static/media/idea-rise.ddafe67d96a00339a27a9008696c52a3.svg";
export { ForwardRef as ReactComponent };